import KsqlDBQuery from './KsqlDBQuery';

export default KsqlDBQuery;
